export const selectShopBy = (state) => state.shopBy;

export const selectProducts = (state) => selectShopBy(state).products.data;
export const selectedProducsLoading = (state) => selectShopBy(state).products.loading;
export const selectProductsScrolling = (state) => selectShopBy(state).products.scrolling;

export const selectTotalProducts = (state) => selectShopBy(state).products.total;
export const selectFilters = (state) => selectShopBy(state).filters.filters;
export const selectSelectedFilters = (state) => selectShopBy(state).filters.selectedFilters;
export const selectPurchaseTypeFilterState = (state) => selectShopBy(state).filters.selectedFilters['Purchase Type'];